<div class="widget-container" #DonutNewChartDiv>
  
  <icon-chart 
    [headerConfig]="item.config?.['widget_header_config']"
    [pageKey]="pageKey"
    [chartName]="'DonutChartNewCard'" 
    [item]="item"
  ></icon-chart>
  
  <loading *ngIf="loader" style="height: 200px;"></loading>

  <div style="height: 200px; width: auto; " *ngIf="!loader && data.length==0">
      <span class="du-scrii-donut-bg-text"> {{ error_name ? error_name : 'There is no data for this time period' }} </span>
  </div>

  <!-- Card Content -->
  <div class="du-scrii-card-content" *ngIf="config && !loader && data?.length > 0">
    <!-- Donut Chart -->
    <div class="du-scrii-chart-wrapper">
      <div #chartContainer class="du-scrii-chart-container" role="img" [attr.aria-label]="config.title + ' donut chart'"></div>
    </div>

    <!-- Legend -->
    <div class="du-scrii-legend" [class.is-two-col]="legendItems.length > 3" role="list" aria-label="Chart legend">
      <div class="du-scrii-legend-item" *ngFor="let item of legendItems; trackBy: trackByLabel" role="listitem">
        <div class="du-scrii-legend-indicator" 
             [style.background-color]="item.color"
             [attr.aria-hidden]="true"></div>
        <div class="du-scrii-legend-content">
          <span class="du-scrii-legend-label" [title]="item.name">{{ item.name }}</span>
          <div class="du-scrii-legend-values">
            <span class="du-scrii-legend-value">{{ item.value | number }}</span>
            <span class="du-scrii-legend-separator" aria-hidden="true">-</span>
            <span class="du-scrii-legend-percentage">{{ item.percentage }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Optional Subtitle -->
  <!-- <div class="du-scrii-card-footer" *ngIf="config.subtitle">
    <p class="du-scrii-subtitle">{{ config.subtitle }}</p>
  </div> -->
</div>